//import React from "react";
import { IRoute } from "../Interfaces/IRoute";
import Home from '../Components/Home/home'
import FamilyGroupAdministrationSearch from "../Components/FamilyGroupAdministration/Search/search";
import ProductSearch from "../Components/Product/Search/search";
import ProductQuery from "../Components/Product/Query/query";
import Management from "../Components/FamilyGroupAdministration/Management/management";
import ContainerTypeMaintenanceSearch from "../Components/ContainerTypeMaintenance/Search/search";
import Summary from "../Components/FamilyGroupAdministration/Summary/summary";
import LdmScanDownload from "../Components/LdmScan/LdmScanDownload";

const routespath: IRoute[] = [
  {
    path: '/home',
    exact: true,
    name: 'Home',
    loader: () => import('../Components/Home/home'),
    component: Home,
    isChild: false,
    hasLinkAccess: false,
    parent: "",
    index: 1
  },
  {
    path: '/familyGroupAdmin',
    exact: true,
    name: 'Family Group Administration',
    component: FamilyGroupAdministrationSearch,
    hasChild: true,
    hasLinkAccess: false,
    parent: "",
    index: 2
  },
  {
    path: '/familyGroupAdmin/summary',
    exact: false,
    name: 'Summary',
    loader: () => import('../Components/FamilyGroupAdministration/Summary/summary'),
    component: Summary,
    isChild: true,
    hasChild: false,
    hasLinkAccess: false,
    parent: '/familyGroupAdmin',
    searchPageReset: "fullPageReset",
    index: 2
  },
  {
    path: '/familyGroupAdmin/management',
    exact: false,
    name: 'Management',
    loader: () => import('../Components/FamilyGroupAdministration/Management/management'),
    component: Management,
    isChild: true,
    hasChild: false,
    hasLinkAccess: false,
    parent: '/familyGroupAdmin',
    deletePopupName: 'familyGroupDeleteManagement',
    createPopupName: 'familyGroupCreateManagement',
    searchPageReset: "fullPageReset",
    index: 2
  },
  {
    path: '/product',
    exact: true,
    name: 'Product',
    component: ProductSearch,
    hasChild: true,
    nestedRoutedParent: true,
    hasLinkAccess: false,
    parent: "",
    index: 3
  },
  {
    path: '/product/query',
    exact: true,
    name: 'Query',
    loader: () => import('../Components/Product/Query/query'),
    component: ProductQuery,
    isChild: true,
    hasChild: false,
    hasLinkAccess: true,
    parent: '/product',
    index: 3
  },
  {
    path: '/product/attributes',
    exact: true,
    name: 'Attributes',
    loader: () => import('../Components/Product/Query/query'),
    component: ProductSearch,
    isChild: true,
    hasChild: false,
    hasLinkAccess: true,
    parent: '/product',
    index: 3
  },
  {
    path: '/product/measurements',
    exact: true,
    name: 'Measurements',
    loader: () => import('../Components/Product/Query/query'),
    component: ProductSearch,
    isChild: true,
    hasChild: false,
    hasLinkAccess: true,
    parent: '/product',
    index: 3
  },
  {
    path: '/product/hierarchy',
    exact: true,
    name: 'Hierarchy',
    loader: () => import('../Components/Product/Query/query'),
    component: ProductSearch,
    isChild: true,
    hasChild: false,
    hasLinkAccess: true,
    parent: '/product',
    index: 3
  },
  {
    path: '/containerTypeMaintenance',
    exact: true,
    name: 'Container Type Maintenance',
    component: ContainerTypeMaintenanceSearch,
    hasChild: true,
    hasLinkAccess: false,
    parent: "",
    index: 5

  },
  {
    path: '/containerTypeMaintenance/management',
    exact: false,
    name: 'Management',
    loader: () => import('../Components/ContainerTypeMaintenance/Search/search'),
    component: Management,
    isChild: true,
    hasChild: false,
    hasLinkAccess: false,
    parent: '/containerTypeMaintenance',
    deletePopupName: 'duTypeDeleteManagement',
    createPopupName: 'duTypeCreateManagement',
    searchPageReset: "fullPageReset",
    index: 5
  },
   {
    path: '/ldm-scan-download',
    exact: false,
    name: 'LDM App',
    loader: () => import('../Components/LdmScan/LdmScanDownload'),
    component: LdmScanDownload,
    isChild: false,
    hasChild: false,
    hasLinkAccess: false,
    parent: "",
    index: 6
  },
]

export default routespath;